import * as Icon from "@ant-design/icons";
import { GeneralStore } from "../../stores";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../../context/user";

export const SidebarItems = () => {
  const { user } = GeneralStore();
  const role = user?.role ?? "";

  const hasRequiredRoles = (requiredRoles) => {
    return requiredRoles.includes(role);
  };

  const isDisabled = (requiredRoles) => {
    return !hasRequiredRoles(requiredRoles);
  };

  return [
    {
      key: "/",
      icon: <Icon.HomeOutlined />,
      label: "Ana Sayfa",
      disabled: isDisabled([
        "Süper Admin",
        "Admin",
        "Öğretmen",
        "Öğrenci",
        "Diyetisyen",
      ]),
    },
    {
      key: "/egitmen",
      icon: <Icon.UserOutlined />,
      label: "Eğitmenler",
      disabled: isDisabled(["Süper Admin", "Admin"]),
    },
    {
      key: "/ogrenciler",
      icon: <Icon.UserOutlined />,
      label: "Öğrenciler",
      disabled: isDisabled(["Süper Admin", "Admin"]),
    },
    {
      key: "/diyetisyen-yonetimi",
      icon: <Icon.UserOutlined />,
      label: "Diyetisyenler",
      disabled: isDisabled(["Süper Admin"]),
    },
    {
      key: "/branslar",
      icon: <Icon.FlagOutlined />,
      label: "Branslar",
      disabled: isDisabled(["Süper Admin", "Admin"]),
    },
    {
      key: "/ogrenci/mesaj",
      icon: <Icon.MessageOutlined />,
      label: "Mesajlar",
      disabled: isDisabled(["Öğrenci"]),
    },
    {
      key: "/egitmen/mesaj",
      icon: <Icon.MessageOutlined />,
      label: "Mesajlar",
      disabled: isDisabled(["Öğretmen"]),
    },
    {
      key: "/kategori",
      icon: <Icon.FileAddOutlined />,
      label: "Kategoriler",
      disabled: isDisabled(["Süper Admin", "Admin"]),
    },
    {
      key: "/cevrimici",
      icon: <Icon.FileSearchOutlined />,
      label: "Kayıt Ol",
      disabled: isDisabled(["Süper Admin", "Admin", "Öğrenci"]),
      danger: true,
    },
    {
      key: "/cevrimicidetay",
      icon: <Icon.CheckSquareOutlined />,
      label: "Kurs Detay",
      disabled: isDisabled(["Süper Admin"]),
    },
    {
      key: "/kurslarim",
      icon: <Icon.GroupOutlined />,
      label: "Kurslarım",
      disabled: isDisabled(["Öğrenci"]),
    },
    {
      key: "/sorumlukurslar",
      icon: <Icon.ScheduleOutlined />,
      label: "Sorumlu Kurslarım",
      disabled: isDisabled(["Öğretmen"]),
    },
    {
      key: "/sorumlu-diyetisyenliklerim",
      icon: <Icon.HeartOutlined />,
      label: "Diyetisyenlik",
      disabled: isDisabled(["Diyetisyen"]),
      children: [
        {
          key: "/sorumlu-diyetisyenliklerim",
          label: "Sorumlu Diyetisyenliklerim",
          icon: <Icon.HeartOutlined />,
        },
        {
          key: "/basvurularim",
          label: "Başvurularım",
          icon: <Icon.FileTextOutlined />,
        },
      ],
    },
    {
      key: "/egitmen/canliders",
      icon: <Icon.GlobalOutlined />,
      label: "Canlı Eğitim",
      disabled: isDisabled(["Öğretmen"]),
    },
    {
      key: "/ogrenci/canliders",
      icon: <Icon.GlobalOutlined />,
      label: "Canlı Eğitim",
      disabled: isDisabled(["Öğrenci"]),
    },
    {
      key: "/diyetisyen/canliders",
      icon: <Icon.GlobalOutlined />,
      label: "Canlı Eğitim",
      disabled: isDisabled(["Diyetisyen"]),
    },
    {
      key: "/basvurular",
      icon: <Icon.FileTextOutlined />,
      label: "Başvurular",
      disabled: isDisabled(["Süper Admin"]),
    },
     {
      key: "/geriodemeler",
      icon: <Icon.RedoOutlined />,
      label: "Geri Ödemeler",
      disabled: isDisabled(["Süper Admin"]),
    },
 
          // {
          //   key: "/canli-egitim-kontrol",
          //   icon: <Icon.ControlOutlined />,
          //   label: "Canlı Eğitim Kontrol",
          //   disabled: isDisabled(["Süper Admin"]),
          // },
        
    {
      key: "/kullanıcılar",
      icon: <Icon.ScheduleOutlined />,
      label: "Kullanıcılar",
      disabled: isDisabled(["Süper Admin", "Admin"]),
    },

    {
      key: "/ogrencilerim",
      icon: <Icon.UserOutlined />,
      label: "Öğrencilerim",
      disabled: isDisabled(["Öğretmen"]),
    },
    {
      key: "/istatistik",
      icon: <Icon.SaveOutlined />,
      label: "İstatistikler",
      disabled: isDisabled(["Süper Admin"]),
    },
    {
      key: "/sms/ogrenci",
      icon: <Icon.InboxOutlined />,
      label: "Sms",
      disabled: isDisabled(["Süper Admin"]),
    },
    {
      key: "/devamsizlik",
      label: "Devamsızlık Takibi",
      icon: <Icon.CalendarOutlined />,
      disabled: isDisabled(["Öğrenci"]),
    },
    {
      key: "/puantaj",
      label: "Puantaj",
      icon: <Icon.CalendarOutlined />,
      disabled: isDisabled(["Süper Admin"]),
    },
    {
      key: "/devamsizlik-kaldir",
      label: "Devamsızlık Kaldır",
      icon: <Icon.CloseCircleOutlined />,
      disabled: isDisabled(["Süper Admin"]),
    },
    {
      key: "/odemeler",
      label: "Ödemeler",
      icon: <Icon.DollarOutlined />,
      disabled: isDisabled(["Öğrenci"]),
    },
    {
      key: "diyetisyenlik",
      label: "Diyetisyenlik",
      icon: <Icon.HeartOutlined />,
      disabled: isDisabled(["Süper Admin", "Öğrenci"]),
      children: [
        {
          key: "/diyetisyenlik/kayit-ekrani",
          label: "Kayıt Ekranı",
          icon: <Icon.FileAddOutlined />,
        },
        ...(role !== "Süper Admin"
          ? [
              {
                key: "/diyetisyenlik/kayitli-randevularim",
                label: "Kayıtlı Randevularım",
                icon: <Icon.CalendarOutlined />,
              },
            ]
          : []),
          ...(role === "Süper Admin"
      ? [
          {
            key: "/diyetisyenlik/detaylar",
            label: "Başvuru Detay",
            icon: <Icon.InfoCircleOutlined />,
          },
           {
            key: "/diyetisyenlik/randevu-detay",
            label: "Randevu Detay",
            icon: <Icon.InfoCircleOutlined />,
          },
        ]
      : [])
      ],
    },
     {
      key: "/ayarlar",
      icon: <Icon.SettingOutlined />,
      label: "Ayarlar",
      disabled: isDisabled(["Süper Admin"]),
    },
     {
      key: "/genel-bilgiler",
      icon: <Icon.InfoCircleOutlined />,
      label: "Genel Bilgiler",
      disabled: isDisabled(["Öğrenci"]),
    }
  ];
};

export const ProfileMenuItems = () => {
  const [state, dispatch] = useContext(UserContext);
  const navigate = useNavigate();
  const { logout } = GeneralStore();
  return [
    {
      key: "home",
      icon: <Icon.HomeOutlined size={16} />,
      label: "Spor Konya",
      onClick: () => {
        window.open("https://www.sporkonya.com.tr/", "_blank");
      },
    },
    {
      key: "panel",
      icon: <Icon.DashboardOutlined size={16} />,
      label: "Panel",
      onClick: () => {
        navigate("/");
      },
    },
    {
      key: "profil",
      icon: <Icon.UserOutlined size={16} />,
      label: "Profil",
      onClick: () => {
        navigate("/profil");
      },
    },
    {
      key: "logout",
      icon: <Icon.LogoutOutlined className="text-red-500" size={16} />,
      label: "Çıkış yap",
      onClick: () => {
        dispatch({ type: "LOGOUT" });
        logout();
        navigate("/giris");
      },
    },
  ];
};
